export const USER_LOGIN_REQUEST = "USER_LOGIN_REQUEST"
export const USER_LOGIN_SUCCESS = "USER_LOGIN_SUCCESS"
export const USER_LOGIN_FAILURE = "USER_LOGIN_FAILURE"
export const CLEAR_LOGIN_ERRORS = "CLEAR_LOGIN_ERRORS"
export const USER_BUSINESS_MAPPING_CREATED = "USER_BUSINESS_MAPPING_CREATED"
export const SET_UNCONFIRMED_EMAIL = "SET_UNCONFIRMED_EMAIL"
export const UPDATE_NEW_BUSINESS = "UPDATE_NEW_BUSINESS"
export const USER_BUSINESS_TYPE = "USER_BUSINESS_TYPE"
export const SET_USER_ALL_BUSINESSES = "SET_USER_ALL_BUSINESSES"
